import Container from '@ui/container/container';
import Text from '@ui/text/text/text';

type CalendarDayProps = {
  dates: {
    date: Date | null;
    fullDate: string | null;
    month: string | null;
    day: string | null;
    timeZone?: Intl.DateTimeFormatOptions['timeZone'];
    localStartDate?: Date | null;
    localEndDate?: Date | null;
  } | null;
};

const CalendarDay = ({ dates }: CalendarDayProps) => {
  if (!dates) return null;
  return (
    <div className="flex-column">
      <Container
        className="flex-column jc-center ai-center padding-v-3 padding-h-4"
        width="48px"
        height="20px"
        background="var(--gray-800)"
        borderRadius="8px 8px 0 0"
        borderWidth="1px"
        borderColor="var(--gray-700)"
      >
        <Text color="var(--gray-300)" className="C3">
          {dates?.month?.toLocaleUpperCase() ?? 'Cal'}
        </Text>
      </Container>
      <Container
        className="flex-column jc-center ai-center padding-v-2 padding-h-4"
        width="48px"
        height="28px"
        borderRadius="0 0 8px 8px"
        borderWidth="0 1px 1px 1px"
        borderColor="var(--gray-700)"
      >
        <Text className="H5">{dates?.day || ''}</Text>
      </Container>
    </div>
  );
};

export default CalendarDay;
